import { Dayjs } from "dayjs";

export interface Report {
    id?: ID;
    object: ReportObject;
    title: string;
    excludedColumns: string[];
    collection: ReportCollection;
    filters: ReportFilter;
    seller?: { id: ID };
    createdAt?: Dayjs;
    createdBy?: { id: ID };
    updatedAt?: Dayjs;
    updatedBy?: { id: ID };
    deletedAt?: Dayjs;
    deletedBy?: { id: ID };
    defaultState?: { filter?: any }; // Default filter applied when none is specified
    showSummary?: boolean;
    hiddenFields?: string[];
    useRedemptionCollection?: boolean;
}

type ReportFilter = Record<string, string>;

export enum ReportCollection {
    ORDERS = "orders",
    PURCHASES = "purchases",
    RESERVATIONS = "purchaseItems",
    TRANSACTIONS = "transactions",
    DRAFTS = "abandonedPurchaseItems",
    CAPACITY = "capacity",
    SCANS = "scans",
    USERS = "users",
    CATALOG_ITEMS = "catalogItems",
}

// These seem to be set in the UI `reportCollection.js` we should do it in the API
export enum ReportObject {
    PURCHASES = "PurchasesReport",
    RESERVATIONS = "ReservationsReport",
    QUESTIONNAIRE = "QuestionnaireReport",
    RESERVATIONS_BY_LISTING = "PurchasesByListingReport",
    ABANDONS = "AbandonedReservationsReport",
    TRANSACTIONS = "TransactionsReport",
    ITEMIZED_PURCHASES = "ItemizedPurchases",
    CAPACITY = "CapacityReport",
    MEMBERSHIP = "MembershipReport",
    TICKET_REDEMPTION = "TicketRedemptionReport",
    CUSTOMERS = "CustomersReport",
    MERCHANDISE_GROSS_SALES = "MerchandiseGrossSalesReport",
    MERCHANDISE_INVENTORY = "MerchandiseInventoryReport",
}

export enum ReportDateFieldType {
    ARRIVAL = "arrivalDate",
    CREATED = "createdAt",
    START = "start",
    ITEM_REALIZED = "items.realizedAt",
}

export interface ElasticsearchResponse {
    aggregations: {
        total: {
            doc_count: number;
            items: any;
        };
    };
    hits: {
        hits: any[];
        max_score: number;
        total: number;
    };
    timed_out: boolean;
    took: number;
    _shards: any;
}
